export const MENU_TRANSPARENT_PART_WIDTH = '85px';

export const MENU_TRANSITION = '0.2s linear';

export const CONTENT_MARGIN = '1rem';
